import { Platform } from "react-native"
import * as Updates from "expo-updates"
import { z } from "@white-labels/input"

import appJson from "../app.json"

const CHANNELS = ["development", "staging", "production"] as const

const schema = z.object({
  channel: z.enum(CHANNELS),
})

function getChannel() {
  if (CHANNELS.includes(Updates.channel as (typeof CHANNELS)[number])) {
    return Updates.channel
  } else {
    return process.env.EXPO_PUBLIC_CHANNEL
  }
}

const channel = getChannel()
const env = schema.parse({ channel })

const DEVICE_IP = "http://192.168.1.65"

export const ENV = {
  development: {
    BASE_URL: Platform.select({ android: `${DEVICE_IP}:8889/trpc/m5azen`, default: `${DEVICE_IP}:8889/trpc/m5azen` }),
    R2_URL: "https://m5azendev.accelerated.work",
    version: appJson.expo.version,
    runtimeVersion: appJson.expo.runtimeVersion,
    ...env,
  },
  staging: {
    BASE_URL: "https://api-staging.a-eid.workers.dev/trpc/m5azen",
    R2_URL: "https://m5azendev.accelerated.work",
    version: appJson.expo.version,
    runtimeVersion: appJson.expo.runtimeVersion,
    ...env,
  },
  production: {
    BASE_URL: "https://api-production.a-eid.workers.dev/trpc/m5azen",
    R2_URL: "https://m5azen-assets.accelerated.work",
    version: appJson.expo.version,
    runtimeVersion: appJson.expo.runtimeVersion,
    ...env,
  },
}[env.channel]
